import { render, staticRenderFns } from "./admin-company-credits.vue?vue&type=template&id=6a611867&"
import script from "./admin-company-credits.ts?vue&type=script&lang=ts&"
export * from "./admin-company-credits.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports